import { TooltippedIconButton } from '@mews-commander/ui';
import { Position } from '@optimus-web/common';
import { Container, Typography, Stack } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { lt, useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { DeleteServiceProductButton } from '../DeleteServiceProductButton';
import type { ServiceCardProps } from '../types';

type HeaderPickedProps = Pick<ServiceCardProps, 'service' | 'enterpriseProductId' | 'productId'>;

interface EditButtonProps {
    toggleEditProductServicesForm: React.DispatchWithoutAction;
}

type ServiceCardHeaderProps = HeaderPickedProps & EditButtonProps;

export const CardHeader = ({
    service,
    enterpriseProductId,
    productId,
    toggleEditProductServicesForm,
}: ServiceCardHeaderProps) => {
    const { id, name } = service;
    const centralProductsEditEnabled = useFeatureFlag(FeatureFlag.centralProductsEditEnabled);

    return (
        <Container padding={['0', '0', '200']}>
            <Stack itemAlignment="center" distribution="space-between">
                <Typography textStyle="titleSmallStrong" as="div">
                    {name || id}
                </Typography>
                <Stack spacing="100">
                    {centralProductsEditEnabled ? (
                        <TooltippedIconButton
                            tooltipPosition={Position.Top}
                            tooltip={lt('EditProductInService')}
                            type="button"
                            size="small"
                            icon={IconName.Edit}
                            onClick={toggleEditProductServicesForm}
                        />
                    ) : null}
                    <DeleteServiceProductButton enterpriseProductId={enterpriseProductId} productId={productId} />
                </Stack>
            </Stack>
        </Container>
    );
};
